export const brandPalette = {
  parchment: '#F7F4EB',
  parchmentStrong: '#fbf8f0',
  surface: '#fffaf2',
  surfaceMuted: '#f7f4eb',
  surfaceHover: '#efe9db',
  border: '#e4ddcd',
  borderStrong: '#ddd4c1',
  borderSoft: '#d8cfbd',
  borderHero: '#e2d6bf',
  title: '#4f5d2f',
  textPrimary: '#4a453b',
  textBody: '#6d654f',
  textMuted: '#7c735f',
  textSubtle: '#8a806a',
  action: '#8fa36b',
  actionHover: '#7f8d57',
  actionPressed: '#6f7d49',
} as const;

export const brandClasses = {
  appShell: 'bg-[#F7F4EB] text-[#4a453b]',
  headerSurface: 'border-[#e4ddcd] bg-[#F7F4EB]/95',
  footerSurface: 'border-[#e4ddcd] bg-[#F7F4EB]',
  warmSurface: 'bg-[#fffaf2]',
  mutedSurface: 'bg-[#f7f4eb]',
  chipSurface: 'border-[#8e846b] bg-[#f7f4eb]',
  infoPanelSurface: 'border-[#8e846b] bg-[#efe9db]',
  elevatedCard: 'border-[#ddd4c1] bg-[#fffaf2] shadow-[0_12px_28px_rgba(95,83,58,0.08)]',
  heroCard: 'rounded-[1.75rem] border border-[#e2d6bf] bg-[#fffaf2] px-6 py-8 shadow-[0_18px_40px_rgba(95,83,58,0.08)]',
  heroBorder: 'border-[#e2d6bf]',
  subtleBorder: 'border-[#e4ddcd]',
  strongBorder: 'border-[#ddd4c1]',
  softBorder: 'border-[#d8cfbd]',
  footerBorder: 'border-[#e5dfd5]',
  textInteractive: 'text-[#6c644f]',
  titleText: 'text-[#4f5d2f]',
  primaryText: 'text-[#4a453b]',
  bodyText: 'text-[#6d654f]',
  mutedText: 'text-[#7c735f]',
  subtleText: 'text-[#8a806a]',
  hoverSurface: 'hover:bg-[#efe9db]',
  hoverPrimaryText: 'hover:text-[#4a453b]',
  actionButton: 'bg-[#8fa36b] text-white hover:bg-[#7f8d57]',
  actionButtonStrong: 'bg-[#7f8d57] text-white hover:bg-[#6f7d49]',
  navActive: 'bg-[#e9e3d4] text-[#4f5d2f]',
  navIdle: 'text-[#6c644f] hover:bg-[#efe9db]',
  titleBarSurface: 'bg-[#fbf8f0]',
} as const;
